module.exports = __webpack_public_path__ + "img/up15.43ca09a7.png";